import { Link } from "react-router-dom";
import { Link as LinkTo } from "react-scroll";
import Logo from './../assets/img/logo.svg'

import "swiper/css";
import './../css/landing.css'

import heroImg1 from './../assets/img/landing/raiders_beta_logo.png'
import BackgroundSwiper from "../components/BackgroundSwiper";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";

import heroImage1 from './../assets/img/landing/hero-img1.png'
import heroImage2 from './../assets/img/landing/hero-img2.png'
import heroImage3 from './../assets/img/landing/hero-img3.png'
import heroImage4 from './../assets/img/landing/hero-img4.png'
import heroImage5 from './../assets/img/landing/hero-img5.png'
import heroImage6 from './../assets/img/landing/hero-img6.png'

import heroBg1 from './../assets/img/landing/hero-bg2.png'
import heroBg2 from './../assets/img/landing/hero-bg3.png'
import heroBg3 from './../assets/img/landing/hero-bg4.png'

import heroSwiper11 from './../assets/img/landing/hero-swiper11.png'
import heroSwiper12 from './../assets/img/landing/hero-swiper12.png'
import heroSwiper121 from './../assets/img/landing/hero-swiper121.png'
import heroSwiper122 from './../assets/img/landing/hero-swiper122.png'
import heroSwiper21 from './../assets/img/landing/hero-swiper21.png'
import heroSwiper22 from './../assets/img/landing/hero-swiper22.png'
import heroSwiper221 from './../assets/img/landing/hero-swiper221.png'
import heroSwiper31 from './../assets/img/landing/hero-swiper31.png'
import heroSwiper32 from './../assets/img/landing/hero-swiper32.png'
import heroSwiper321 from './../assets/img/landing/hero-swiper321.png'
import heroSwiper41 from './../assets/img/landing/hero-swiper41.png'
import heroSwiper42 from './../assets/img/landing/hero-swiper42.png'
import heroSwiper421 from './../assets/img/landing/hero-swiper421.png'
import heroSwiper51 from './../assets/img/landing/hero-swiper51.png'
import heroSwiper52 from './../assets/img/landing/hero-swiper52.png'
import heroSwiper521 from './../assets/img/landing/hero-swiper521.png'
import heroSwiper61 from './../assets/img/landing/hero-swiper61.png'
import heroSwiper62 from './../assets/img/landing/hero-swiper62.png'
import heroSwiper621 from './../assets/img/landing/hero-swiper62-1.png'

import meet1 from './../assets/img/landing/meet1.png'
import meet2 from './../assets/img/landing/meet2.png'
import meet3 from './../assets/img/landing/meet3.png'
import meet4 from './../assets/img/landing/meet4.png'
import meet5 from './../assets/img/landing/meet5.png'
import meet6 from './../assets/img/landing/meet6.png'
import meet7 from './../assets/img/landing/meet7.png'
import meet8 from './../assets/img/landing/meet8.png'
import meet9 from './../assets/img/landing/meet9.png'
import meet10 from './../assets/img/landing/meet10.png'
import meet11 from './../assets/img/landing/meet11.png'
import meet12 from './../assets/img/landing/meet12.png'
import meet13 from './../assets/img/landing/meet13.png'

import videoBg from './../assets/img/landing/video-bg.png'
import videoBg1 from './../assets/img/landing/video-bg1.png'
import videoBg2 from './../assets/img/landing/video-bg2.png'
import metaverseBg from './../assets/img/landing/metaverse-bg.png'

import mystery from './../assets/img/landing/mystery.png'

import mystery1 from './../assets/img/landing/mystery1.png'
import mystery2 from './../assets/img/landing/mystery2.png'
import mystery3 from './../assets/img/landing/mystery3.png'
import mystery4 from './../assets/img/landing/mystery4.png'

import wastelands1 from './../assets/img/landing/wastelands1.png'
import wastelands2 from './../assets/img/landing/wastelands2.png'

import wastelands1Swiper from './../assets/img/landing/wastelands-swiper1.png'
import wastelands2Swiper from './../assets/img/landing/wastelands-swiper2.png'
import wastelands3Swiper from './../assets/img/landing/wastelands-swiper3.png'
import wastelands4Swiper from './../assets/img/landing/wastelands-swiper4.png'
import wastelands5Swiper from './../assets/img/landing/wastelands-swiper5.png'
import wastelands6Swiper from './../assets/img/landing/wastelands-swiper6.png'
import wastelands7Swiper from './../assets/img/landing/wastelands-swiper7.png'
import wastelands8Swiper from './../assets/img/landing/wastelands-swiper8.png'

import wastelandsChoose1 from './../assets/img/landing/wastelands-choose1.png'
import wastelandsChoose2 from './../assets/img/landing/wastelands-choose2.png'
import wastelandsChoose3 from './../assets/img/landing/wastelands-choose3.png'

//import news1 from './../assets/img/landing/news1.png'
//import news2 from './../assets/img/landing/news2.png'
//import news3 from './../assets/img/landing/news3.png'
import news4 from './../assets/img/landing/news4.png'
import news5 from './../assets/img/landing/news5.png'
import news6 from './../assets/img/landing/news6.png'
import news7 from './../assets/img/landing/news7.png'
import news8 from './../assets/img/landing/news8.png'




import contactsBg1 from './../assets/img/landing/contacts1.png'
import contactsBg2 from './../assets/img/landing/contacts2.png'
import contactsBg3 from './../assets/img/landing/contacts3.png'
import contactsBg4 from './../assets/img/landing/contacts4.png'
import contactsBg5 from './../assets/img/landing/contacts5.png'
import contactsBg6 from './../assets/img/landing/contacts6.png'

import whitepaper from './../assets/whitepaper.pdf'

import { useEffect, useRef, useState } from "react";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default function Landing () {

    document.title = 'Raiders • Home'

    const hero = [
        {   
            name: 'heroSwiper1',
            class: ['hero__slide-lizer1', 'hero__slide-lizer2'],
            bg: heroSwiper11,
            img: heroSwiper12,
            add: [heroSwiper121, heroSwiper122],
        },
        {
            name: 'heroSwiper2',
            class: ['hero__slide-head'],
            bg: heroSwiper21,
            img: heroSwiper22,
            add: [heroSwiper221],
        },
        {
            name: 'heroSwiper3',
            class: ['hero__slide-candy'],
            bg: heroSwiper31,
            img: heroSwiper32,
            add: [heroSwiper321],
        },
        {
            name: 'heroSwiper4',
            class: ['hero__slide-bird'],
            bg: heroSwiper41,
            img: heroSwiper42,
            add: [heroSwiper421],
        },
        {
            name: 'heroSwiper5',
            class: ['hero__slide-pinta'],
            bg: heroSwiper51,
            img: heroSwiper52,
            add: [heroSwiper521],
        },
        {
            name: 'heroSwiper6',
            class: ['hero__slide-saw'],
            bg: heroSwiper61,
            img: heroSwiper62,
            add: [heroSwiper621],
        },
    ]

    const cards = [meet1, meet2, meet3, meet4, meet5, meet6, meet7, meet8, meet9, meet10, meet11, meet12, meet13]

    const mysterys = [
        {
            img: mystery1,
            name: 'COMMON'
        },
        {
            img: mystery2,
            name: 'RARE'
        },
        {
            img: mystery3,
            name: 'EPIC'
        },
        {
            img: mystery4,
            name: 'LEGENDARY'
        }
    ]

    const wastelandSwiper = [wastelands4Swiper, wastelands2Swiper, wastelands7Swiper, wastelands3Swiper, wastelands1Swiper, wastelands5Swiper, wastelands6Swiper, wastelands8Swiper]

    const [choose, setChoose] = useState('common')

    const news = [
        {
            img: news4,
            title: 'Constitution',
            subtitle: 'The fundamental principles of the Wastelands',
            descr: '1. Raiders have gathered in the wastelands to earn a living. Raiders have gathered in the wastelands to have fun as well....',
            date: '20.03.2024',
            time: '2 min',
            theme: 'Discover',
            themeLink: 'https://constitution.rgw.zone/'
        }, 
        {
            img: news5,
            title: 'Sales history',
            subtitle: 'Keep an eye on price changes',
            descr: 'The price of NFT chests is variable. If a sales round is overbooked, we will raise the price for the next round. Conversely, if demand is low, we will lower the price.',
            date: '11.05.2024',
            time: '<1 min',
            theme: 'Discover',
            themeLink: 'https://constitution.rgw.zone/sales-history',
        },
        {
            img: news6,
            title: 'NFT we use',
            subtitle: 'Learn more about NFT in our project',
            descr: 'Mystery Boxes, Villages, Characters and Cryptucurency token $RGC. Chains, Standarts, DAO usage and game proposes',
            date: '14.05.2024',
            time: '<1 min',
            theme: 'Discover',
            themeLink: 'https://constitution.rgw.zone/inventory'
        },
        {
            img: news8,
            title: 'New characters',
            subtitle: 'A little bit of statistics about the next character pack',
            descr: 'It will include 9 characters: Water Reader, Cock, Dancer, Lurker, Madman, Predator, Stalker, Sweety and Teacher',
            date: '01.08.2024',
            time: '<1 min',
            theme: 'Discover',
            themeLink: 'https://constitution.rgw.zone/new-characters'
        }
    ]

    const [textWriter, setTextWriter] = useState('A RAIDER')

    useEffect(() => {

        const TxtType = function(el, toRotate, period) {
            this.toRotate = toRotate;
            this.el = el;
            this.loopNum = 0;
            this.period = parseInt(period, 10) || 2000;
            this.txt = '';
            this.tick();
            this.isDeleting = false;
        };
    
        TxtType.prototype.tick = function() {
            var i = this.loopNum % this.toRotate.length;
            var fullTxt = this.toRotate[i];
    
            if (this.isDeleting) {
                this.txt = fullTxt.substring(0, this.txt.length - 1);
            } else {
                this.txt = fullTxt.substring(0, this.txt.length + 1);
            }
    
            this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';
    
            var that = this;
            var delta = 200 - Math.random() * 100;
    
            if (this.isDeleting) { delta /= 2; }
    
            if (!this.isDeleting && this.txt === fullTxt) {
                delta = this.period;
                this.isDeleting = true;
            } else if (this.isDeleting && this.txt === '') {
                this.isDeleting = false;
                this.loopNum++;
                delta = 500;
            }
    
            setTimeout(function() {
                that.tick();
            }, delta);
        };
    
        window.onload = function() {
            const elements = document.getElementsByClassName('mystery__become-span');
            for (var i=0; i<elements.length; i++) {
                var toRotate = elements[i].getAttribute('data-type');
                var period = elements[i].getAttribute('data-period');
                if (toRotate) {
                  new TxtType(elements[i], JSON.parse(toRotate), period);
                }
            }
            // INJECT CSS
            var css = document.createElement("style");
            css.type = "text/css";
            css.innerHTML = ".mystery__become-span > .wrap { border-right: 0.08em solid #fff}";
            document.body.appendChild(css);
        };

    }, [])
    
    const [startHeroAnim, setStartHeroAnim] = useState(1)

    const el = useRef()
    const q = gsap.utils.selector(el)

    const animMeet1 = useRef()
    const animMetaverse1 = useRef()
    const animMystery1 = useRef()
    const animWasteland1 = useRef()
    const animNews1 = useRef()
    const animContacts1 = useRef()

    useEffect(() => {
        animMeet1.current = gsap.timeline({
            scrollTrigger: {
                trigger: '.meet',
                start: 'top center',
                pin: false,
            }
        }).to(q('.meet__title'), {
            y: 0,
            opacity: 1,
            duration: 1
        }).to(q('.meet__anim2'), {
            y: 0,
            opacity: 1,
            duration: 1
        })

        animMetaverse1.current = gsap.timeline({
            scrollTrigger: {
                trigger: '.metaverse',
                start: 'top center',
                pin: false,
            }
        }).to(q('.metaverse__title'), {
            y: 0,
            opacity: 1,
            duration: 1
        }).to(q('.metaverse__anim2'), {
            y: 0,
            opacity: 1,
            duration: 1
        }).to(q('.metaverse__anim3'), {
            y: 0,
            opacity: 1,
            duration: 1
        })

        animMystery1.current = gsap.matchMedia()
        animMystery1.current.add('(min-width: 961px)', () => {
            let anim1 = gsap.timeline({
                scrollTrigger: {
                    trigger: '.mystery',
                    start: 'top center',
                    pin: false,
                }
            })
            anim1.to(q('.myster__anim1'), {
                y: 0,
                opacity: 1,
                duration: 1
            }).to(q('.myster__anim2'), {
                y: 0,
                opacity: 1,
                duration: 1
            })
        }).add('(max-width: 960px)', () => {
            let anim1 = gsap.timeline({
                scrollTrigger: {
                    trigger: '.mystery',
                    start: 'top center',
                    pin: false,
                }
            })
            anim1.to(q('.myster__anim1'), {
                y: 0,
                opacity: 1,
                duration: 1
            }).to(q('.myster__anim2'), {
                y: 0,
                opacity: 1,
                duration: 1
            })
        })

        animWasteland1.current = gsap.matchMedia()
        animWasteland1.current.add('(min-width: 961px)', () => {
            let anim1 = gsap.timeline({
                scrollTrigger: {
                    trigger: '.wasteland',
                    start: 'center bottom',
                    pin: false,
                }
            })
            anim1.to(q('.wasteland__anim1'), {
                y: 0,
                opacity: 1,
                duration: 1
            }).to(q('.wasteland__anim2'), {
                y: 0,
                opacity: 1,
                duration: 1
            }).to(q('.wasteland__anim3'), {
                y: 0,
                opacity: 1,
                duration: 1
            })
        }).add('(max-width: 960px)', () => {
            let anim1 = gsap.timeline({
                scrollTrigger: {
                    trigger: '.wasteland',
                    start: 'top center',
                    pin: false,
                }
            })
            anim1.to(q('.wasteland__anim1'), {
                y: 0,
                opacity: 1,
                duration: 1
            }).to(q('.wasteland__anim2'), {
                y: 0,
                opacity: 1,
                duration: 1
            }).to(q('.wasteland__anim3'), {
                y: 0,
                opacity: 1,
                duration: 1
            })
        })

        animNews1.current = gsap.timeline({
            scrollTrigger: {
                trigger: '.news',
                start: 'center bottom',
                pin: false,
            }
        }).to(q('.news__anim1'), {
            y: 0,
            opacity: 1,
            duration: 1
        }).to(q('.news__anim2'), {
            y: 0,
            opacity: 1,
            duration: 1
        })

        animContacts1.current = gsap.timeline({
            scrollTrigger: {
                trigger: '.contacts',
                start: 'center bottom',
                pin: false,
            }
        }).to(q('.contacts__anim1'), {
            y: 0,
            opacity: 1,
            duration: 1
        }).to(q('.contacts__anim2'), {
            y: 0,
            opacity: 1,
            duration: 1
        })
    }, [])

    const [select, setSelect] = useState('Only news')

    const selectorRef = useRef(null)
    const animSelect = useRef()

    useEffect(() => {
        animSelect.current = gsap.timeline({paused: true}).to(selectorRef.current, {
            height: 'auto',
            duration: 0.5,
        })
    }, [selectorRef])

    return (
        <>
            <main ref={el} className="landing">
                <section id="hero" className="section hero">
                    <BackgroundSwiper>
                        <div className="root__bg root__bg1"  style={{ backgroundImage: `linear-gradient(to bottom, rgba(0,27,77,0.9), rgba(20,20,28,0.9)), url(${heroBg1})` }} />
                        <div className="root__bg root__bg2"  style={{ backgroundImage: `linear-gradient(to bottom, rgba(0,27,77,0.9), rgba(20,20,28,0.9)), url(${heroBg2})` }} />
                        <div className="root__bg root__bg3"  style={{ backgroundImage: `linear-gradient(to bottom, rgba(0,27,77,0.9), rgba(20,20,28,0.9)), url(${heroBg3})` }} />
                    </BackgroundSwiper>
                    <div className="hero__container landing-container">
                        <div className="hero__left">
                            <nav className="hero__nav">
                                <Link to='/' className="hero__logo">
                                    <img src={Logo} className="hero__logo-svg"/>
                                </Link>
                                <div className="hero__link">
                                    <Link to="/dao?menu=true" className="hero__link-descr">
                                        CONNECT
                                    </Link>
                                </div>
                                <div className="hero__link">
                                    <Link to="/dao/drops" className="hero__link-descr">
                                        BUY NFT BOX
                                    </Link>
                                </div>

                                <div className="hero__link">
                                    <Link to="/dao" className="hero__link-descr">
                                        DAO
                                    </Link>
                                </div>
                                <div className="hero__link">
                                    <a
                                        href="https://constitution.rgw.zone"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hero__link-descr"
                                    >
                                        WASTELANDS CONSTITUTION
                                    </a>
                                </div>
                                <br></br>
                                <div className="hero__link">
                                    <LinkTo
                                        spy={true}
                                        smooth={true}
                                        offset={0}
                                        duration={750} 
                                        to="metaverse"
                                        className="hero__link-descr"
                                    >
                                         IDEA
                                    </LinkTo>
                                </div>
                                <div className="hero__link">
                                    <LinkTo
                                        spy={true}
                                        smooth={true}
                                        offset={0}
                                        duration={750} 
                                        to="news"
                                        className="hero__link-descr"
                                    >
                                         NEWS
                                    </LinkTo>
                                </div>
                                <div className="hero__link">
                                    <LinkTo
                                        spy={true}
                                        smooth={true}
                                        offset={0}
                                        duration={750} 
                                        to="contacts"
                                        className="hero__link-descr"
                                    >
                                         CONTACTS
                                    </LinkTo>
                                </div>
                            </nav>
                            <div className="hero__swipe">
                                <div className="hero__swipers">
                                    <Swiper
                                        navigation={{
                                            nextEl: '.hero__btn--next',
                                            prevEl: '.hero__btn--prev'
                                        }}
                                        modules={[Navigation, Autoplay, Pagination]} 
                                        loop={true}
                                        autoplay={{
                                            delay: 5000,
                                            disableOnInteraction: false,
                                        }}
                                        pagination={{
                                            clickable: true,
                                            el: '.hero__paginations',
                                            bulletClass: 'hero__pagination',
                                            bulletActiveClass: 'hero__pagination--active'
                                        }}
                                        slidesPerView={1}
                                        spaceBetween={20}
                                        className="hero__swiper"
                                        onSlideChange={(e) => {
                                            setStartHeroAnim(e.snapIndex)
                                        }}
                                    >
                                        {hero.map((x, i) => {
                                            return (
                                                <SwiperSlide key={i} className="hero__slide">
                                                    <img src={x.bg} alt="" className="hero__slide-bg" onLoad={(e) => {
                                                        console.log('load finished')
                                                    }}/>
                                                    <div className="hero__slide-image">
                                                        <img src={x.img} alt="" className="hero__slide-img" style={{
                                                            bottom: x.name === 'heroSwiper1' ? '-3%' : (x.name === 'heroSwiper3' ? '-5%' : 0),
                                                            objectPosition: x.name === 'heroSwiper6' || x.name === 'heroSwiper1' ? 'right bottom' : 'center bottom',
                                                            height: x.name === 'heroSwiper2' ? '70%' : (x.name === 'heroSwiper1' ? '90%' : '100%'),
                                                            right: x.name === 'heroSwiper3' ? '-20px' : 'auto'
                                                        }} />
                                                        {x.add != null ? 
                                                            x.add.map((j, k) => {
                                                                return (
                                                                    <img key={k} className={x.class[k]} alt="" src={j} style={{
                                                                        animationPlayState: startHeroAnim - 1 === i || (startHeroAnim === 7 && x.name === 'heroSwiper1') || (startHeroAnim === 0 && x.name === 'heroSwiper6') ? 'running' : 'paused'
                                                                    }}/>
                                                                )
                                                            }): null}
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        })}
                                    </Swiper>
                                    
                                    <div className="hero__btns">
                                        <button className="hero__btn hero__btn--prev">
                                            <svg width="30" height="30" viewBox="0 0 30 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.75" y="14.4299" width="28.86" height="0.779999" fill="currentColor"/>
                                                <rect x="0.359985" y="14.82" width="14.04" height="0.779999" transform="rotate(-45 0.359985 14.82)" fill="currentColor"/>
                                                <rect x="0.911499" y="14.2684" width="14.04" height="0.779999" transform="rotate(45 0.911499 14.2684)" fill="currentColor"/>
                                            </svg>
                                        </button>
                                        <button className="hero__btn hero__btn--next">
                                            <svg width="31" height="31" viewBox="0 0 31 31" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="29.83" y="15.89" width="28.86" height="0.779999" transform="rotate(180 29.83 15.89)" fill="currentColor"/>
                                                <rect x="30.22" y="15.4999" width="14.04" height="0.779999" transform="rotate(135 30.22 15.4999)" fill="currentColor"/>
                                                <rect x="29.6685" y="16.0514" width="14.04" height="0.779999" transform="rotate(-135 29.6685 16.0514)" fill="currentColor"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <ul className="hero__paginations"/>
                            </div>
                        </div>
                        <div className="hero__right">
                            <img src={heroImg1} alt="" className="hero__right-img" />
                            <h3 className="hero__right-subtitle">
                                Raiders of the Great Wastelands project
                            </h3>
                            <p className="hero__right-descr">
                            We are a community of enthusiasts united by our shared passion for post-apocalyptic stories. Our goal is to create a unique project where everyone can become a part of our universe.


                            </p>
                            <div>
                            <p>
                                                                <a href="https://constitution.rgw.zone/" target="_blank" rel="noopener noreferrer" className="hero__right-whitepaper">Read the Constitution!</a>
                            </p>
                        </div>

                        </div>
                    </div>
                    <div className="hero__bg">
                        <img src={heroImage1} alt="" className="hero__bg-img hero__bg-img1" />
                        <img src={heroImage2} alt="" className="hero__bg-img hero__bg-img2" />
                        <img src={heroImage3} alt="" className="hero__bg-img hero__bg-img3" />
                        <img src={heroImage4} alt="" className="hero__bg-img hero__bg-img4" />
                        <img src={heroImage5} alt="" className="hero__bg-img hero__bg-img5" />
                        <img src={heroImage6} alt="" className="hero__bg-img hero__bg-img6" />
                    </div>
                </section>
                <div className="landing-color"> 
                    <section id="meet" className="section meet">
                        <div className="meet__container landing-container">
                            <div className="meet__left">
                                <h2 className="meet__title">
                                    Meet<span className="meet__title-span">The Raiders</span>
                                </h2>
                                
                                <p className="meet__descr meet__anim2">
                                NFT characters in the "Great Wasteland Raiders" project are digital assets with character attributes, faction affiliations, roles, unique designs, and rarity. 
                                </p>
                                <p className="meet__descr meet__anim2">
                                Owners of NFT characters can impact the game world, participate in DAO-based voting, hold options to purchase project shares, and be part of an active community influencing the development of the "Great Wasteland Raiders" universe. 
                                </p>

                                <p className="meet__descr meet__anim2">
                                Character cards also engage in mini-games on the website. 
                                </p>
                                
                                <p className="meet__descr meet__anim2">
                                    FACTIONS:
                                </p>
                                <ul className="meet__list">
                                    <li className="meet__item">
                                        <p className="meet__item-descr meet__anim2">
                                            &mdash;&nbsp;<span className="metaverse__subtitle--boldgreen">Valkyries</span>
                                        </p>
                                        <p className="meet__item-descr meet__anim2">
                                            &mdash;&nbsp;<span className="metaverse__subtitle--boldblue">Gentlemen</span>
                                        </p>
                                        <p className="meet__item-descr meet__anim2">
                                            &mdash;&nbsp;<span className="metaverse__subtitle--boldbrown">Primals</span>
                                        </p>
                                    </li>
                                    <li className="meet__item">
                                        <p className="meet__item-descr meet__anim2">
                                            &mdash;&nbsp;<span className="metaverse__subtitle--boldred">Hyenas</span>
                                        </p>
                                        <p className="meet__item-descr meet__anim2">
                                            &mdash;&nbsp;<span className="metaverse__subtitle--boldviolet">Flawless</span>
                                        </p>
                                        <p className="meet__item-descr meet__anim2">
                                            &mdash;&nbsp;Or neutral <span className="metaverse__subtitle--boldyellow">Outcasts</span>
                                        </p>
                                    </li>
                                </ul>
                                
                                <div className="meet__bottom">
                                    <Link to='/dao/drops' className="meet__bottom-link meet__anim2">
                                        Buy NFT BOX
                                    </Link>
                                </div>
                            </div>
                            <div className="meet__right">
                                <div className="meet__right-top">
                                    <h4 className="meet__right-title meet__anim2">
                                        NFT raiders
                                    </h4>
                                    <div className="meet__right-btns meet__anim2">
                                        <button className="meet__right-btn meet__right-btn--left">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.631592" width="33.0479" height="0.893188" transform="rotate(45 0.631592 0)" fill="currentColor"/>
                                                <rect width="16.0774" height="0.893188" fill="currentColor"/>
                                                <rect x="0.893188" width="16.0774" height="0.893188" transform="rotate(90 0.893188 0)" fill="currentColor"/>
                                            </svg>
                                        </button>
                                        <button className="meet__right-btn meet__right-btn--right">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="23.3684" y="24" width="33.0479" height="0.893188" transform="rotate(-135 23.3684 24)" fill="currentColor"/>
                                                <rect x="24" y="24" width="16.0774" height="0.893188" transform="rotate(180 24 24)" fill="currentColor"/>
                                                <rect x="23.1068" y="24" width="16.0774" height="0.893188" transform="rotate(-90 23.1068 24)" fill="currentColor"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <Swiper
                                    slidesPerView={1}
                                    breakpoints={{
                                        1000: {
                                            slidesPerView: 2,
                                        }
                                    }}
                                    spaceBetween={30}
                                    navigation={{
                                        nextEl: '.meet__right-btn--right',
                                        prevEl: '.meet__right-btn--left'
                                    }}
                                    modules={[Navigation]}
                                    className="meet__right-swiper"
                                >
                                    {cards.map((x, i) => {
                                        return (
                                            <SwiperSlide key={i} className="meet__right-slide meet__card">
                                                <img src={x} alt="" className="meet__card-img" />
                                            </SwiperSlide>
                                        )
                                    })}
                                </Swiper>
                                <div className="meet__right-bottom" style={{
                                    display: 'none'
                                }}>
                                    <div className="meet__right-block">
                                        <p className="meet__right-sort">
                                            Sort by:
                                        </p>
                                        <button className="meet__right-descr">
                                            Item attribute
                                        </button>
                                        <button className="meet__right-descr">
                                            Character attribute
                                        </button>
                                    </div>
                                    <button className="meet__right-clear">
                                        Clear sorting
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section id="metaverse" className="section metaverse">
                        <div className="metaverse__container landing-container">
                            <div className="metaverse__left">
                                <div className="metaverse__left-top">
                                    <h2 className="metaverse__title">
                                    <span className="metaverse__title--red">Raiders</span> Key idea
                                    </h2>
                                    <p className="metaverse__subtitle metaverse__anim2">
                                     <span className="metaverse__subtitle--bold">...is that we are raising funds from the crypto investor community by selling gaming assets, and using the collected funds to create a game for a mass audience, where crypto investors can profitably sell their gaming assets to ordinary, non-crypto players through an in-game exchange.</span>
                                 </p>
                                    
                                </div>
                                <div className="metaverse__right-top metaverse__video">
                                    <p className="metaverse__video-name">
                                        Meet the Raiders!
                                    </p>
                                    <a href="https://youtu.be/wArmoIOvWWM" target={'_blank'} rel="noopener noreferrer" className="metaverse__video-link">
                                        <img src={videoBg1} alt="" className="metaverse__video-bg1" />
                                        <svg className="metaverse__video-play" width="63" height="73" viewBox="0 0 63 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M61.9769 33.323C62.1438 33.4115 62.156 33.6461 61.999 33.7514L5.33601 71.7735C5.17475 71.8817 4.95708 71.7727 4.94704 71.5788L1.32427 1.58809C1.31423 1.39415 1.51949 1.26332 1.69105 1.3543L61.9769 33.323Z" stroke="currentColor" strokeWidth="1.5"/>
                                        </svg>
                                        
                                    </a>
                                    <a href="https://youtu.be/wArmoIOvWWM" target={'_blank'} rel="noopener noreferrer" className="metaverse__video-watch">
                                        Raiders reveal 1
                                    </a>
                                    <br></br>
                                    <a href="https://youtu.be/pj0d0LSC0FQ" target={'_blank'} rel="noopener noreferrer" className="metaverse__video-link">
                                        <img src={videoBg2} alt="" className="metaverse__video-bg2" />
                                        <svg className="metaverse__video-play" width="63" height="73" viewBox="0 0 63 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M61.9769 33.323C62.1438 33.4115 62.156 33.6461 61.999 33.7514L5.33601 71.7735C5.17475 71.8817 4.95708 71.7727 4.94704 71.5788L1.32427 1.58809C1.31423 1.39415 1.51949 1.26332 1.69105 1.3543L61.9769 33.323Z" stroke="currentColor" strokeWidth="1.5"/>
                                        </svg>
                                    </a>
                                    {/* <a href="https://youtu.be/pj0d0LSC0FQ" target={'_blank'} rel="noopener noreferrer" className="metaverse__video-watch">
                                        Raiders reveal 1
                                    </a> */}
                                    <a href="https://youtu.be/pj0d0LSC0FQ" target={'_blank'} rel="noopener noreferrer" className="metaverse__video-watch">
                                            Raiders reveal 2
                                        </a>


                                    {/* <div className="metaverse__video-info">
                                        <p className="metaverse__video-name">
                                            Meet the Raiders!
                                        </p>
                                        <a href="https://youtu.be/wArmoIOvWWM" target={'_blank'} rel="noopener noreferrer" className="metaverse__video-watch">
                                            Watch video!
                                        </a>
                                        
                                    </div> */}
                                </div>
                            </div>
                            <div className="metaverse__right">
                                <div id="goals" className="goals-section">
                                    <div className="metaverse__left-bottom metaverse__anim2">
                                        <div className="metaverse__left-flex">
                                            <p className="metaverse__characters"/>
                                            <p className="metaverse__nft">
                                                Goals
                                            </p>
                                        </div>
                                        <ul className="meet__list">
                                            <li className="meet__item">
                                                <p className="meet__item-descr meet__anim2">
                                                    The Raiders Universe is a story of friendship and betrayal, cruelty and love, the fall of humanity and the hope for salvation. <br></br><br></br><span className="metaverse__subtitle--bold">We want to tell this story.</span><br></br><br></br>We plan to create a wide range of media products, including <span className="metaverse__subtitle--bold">comics</span> and <span className="metaverse__subtitle--bold">minigames</span>, <span className="metaverse__subtitle--bold">animated films</span>, and <span className="metaverse__subtitle--bold">real-world events</span>. <br></br> And most importantly &mdash;&nbsp; we will eventually make a <span className="metaverse__subtitle--bold">free-to-play game </span>where crypto investors can sell their assets to ordinary players and earn money, or simply play the game. <br></br><br></br> Come, vote, and let's make this happen together!
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="metaverse__right-bottom metaverse__anim3">
                                    <p className="metaverse__nft">
                                        What's on?
                                    </p>
                                    <p className="metaverse__characters"/>
                                    <div className="meet_list">
                                        <div className="meet__item-descr meet__anim2">
                                            &mdash;&nbsp; <span className="metaverse__subtitle--bold">Trading System</span>: Participate in sales and purchase NFTs at fair prices.
                                            <p className="meet__item-descr meet__anim2">
                                                &mdash;&nbsp;<span className="metaverse__subtitle--bold">DAO</span>-based Voting: Your voice matters. Decide on the next steps.
                                            </p>
                                            <p className="meet__item-descr meet__anim2">
                                                &mdash;&nbsp;<span className="metaverse__subtitle--bold">MLM</span> System: Invite friends and <span className="metaverse__subtitle--bold">earn</span>.
                                            </p>
                                            <p className="meet__item-descr meet__anim2">
                                                &mdash;&nbsp;<span className="metaverse__subtitle--bold">Exploring the Wastelands</span>: Investigate and learn more about the world of Raiders. (in development)
                                            </p>
                                            <p className="meet__item-descr meet__anim2">
                                                &mdash;&nbsp;<span className="metaverse__subtitle--bold">NFT cards</span> Web-Games: Compete with other players and earn unique rewards. (in development)
                                            </p>
                                            <p className="meet__item-descr meet__anim2">
                                                &mdash;&nbsp;<span className="metaverse__subtitle--bold">Role-Playing Story</span>: Help shape the history and future of this universe through DAO. (in development)
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <img src={metaverseBg} alt="" className="metaverse__bg" />
                    </section>
                    <section id="mystery" className="section mystery">
                        <div className="mystery__top landing-container">
                            <div className="mystery__top-left myster__anim1">
                                <p className="mystery__subtitle">
                                    Titles and citizenship
                                </p>
                                <p className="mystery__become">
                                    How&nbsp;to become 
                                    <span className="mystery__become-span" data-period="1500" data-type='[ "A RAIDER", "A BARON", "AN EARL", "A DUKE" ]' >
                                        A RAIDER |
                                    </span>
                                </p>
                                <p className="mystery__text">
                                To become a <span className="metaverse__subtitle--bold">Raider</span> you'll need to own a Character card on your account. You can acquire one by purchasing&nbsp;
                                    <Link to="/dao/drops" className="mystery__buy myster__anim1">
                                       a Mystery box
                                    </Link>
                                    containing a random character from us or selecting one from the secondary market.
                                <br/><br/>
                                To attain the title of <span className="metaverse__subtitle--bold">Baron</span>, you must possess a Village card.
                                <br/><br/>
                                The title of <span className="metaverse__subtitle--bold">Earl</span> is granted as a special gift. To achieve it, you must perform a significant action to earn a personal Raider card and additional privileges. More details can be found in the Constitution.
                                <br/><br/>

                                For the title of <span className="metaverse__subtitle--bold">Duke</span>, you can apply for a position with the Raiders!
                                </p>
                            </div>
                            <img src={mystery} alt="" className="mystery__top-center mystery__img" />
                            <div className="mystery__top-right">
                                <h2 className="mystery__title myster__anim1">
                                To purchase a box, follow these steps:

                                </h2>
                                <p className="mystery__descr myster__anim1">
                                    1. Check the "Order Placement" status, which should be "Open" when we're accepting requests.
                                    <br/><br/>
                                    2. Take note of the "Time Left," which indicates the remaining time for request submissions.
                                    <br/><br/>
                                    3. Choose a box that suits your preferences.
                                    <br/><br/>
                                    4. Monitor the scale to track the request progress.
                                    <br/><br/>
                                    5. If we receive fewer requests than the minimum required ("min"), the sale won't proceed. If the number of requests falls between "min" and "max," most requests will be approved. If it exceeds "max," some requests will be rejected.
                                    <br/><br/>
                                    6. Look out for request approval notifications, and once your request is approved, proceed to pay for your selected box.
                                    <br/><br/>
                                    7. Upon opening the box, you'll receive NFT cards and the opportunity to participate in our MLM program.
                                    <br/><br/>
                                    8. These cards essentially function as shares in the Great Wasteland Raiders, where we collaboratively determine pricing, striving for fairness.
                                    <br/><br/>
                                    9. Join us and Best Luck!
                                </p>
                                <Link to="/dao/drops" className="mystery__buy myster__anim1">
                                    Buy NFT box!
                                </Link>
                            </div>
                        </div>
                        <ul className="mystery__bottom mystery__list landing-container">
                            {mysterys.map((x, i) => {
                                return (        
                                    <li key={i} className="mystery__item" >
                                        <img src={x.img} alt="" className="mystery__item-img" />
                                        <p className="mystery__item-name myster__anim2">
                                            {x.name}
                                        </p>
                                    </li>
                                )
                            })}
                        </ul>
                    </section>
                    <section id="wasteland" className="section wasteland">
                        <div className="wasteland__top landing-container">
                            <div className="wasteland__left">
                                <img src={wastelands1} alt="" className="wasteland__img wasteland__anim2" />
                                <div className="wasteland__block">
                                    <div className="wasteland__btns">
                                        <button className="wasteland__btn wasteland__btn--left">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.631592" width="33.0479" height="0.893188" transform="rotate(45 0.631592 0)" fill="currentColor"/>
                                                <rect width="16.0774" height="0.893188" fill="currentColor"/>
                                                <rect x="0.893188" width="16.0774" height="0.893188" transform="rotate(90 0.893188 0)" fill="currentColor"/>
                                            </svg>
                                        </button>
                                        <div className="wasteland__btn-separation">
                                            <svg className="wasteland__btn-round" width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.395333 4.08739C0.274246 2.35578 1.57984 0.853866 3.31145 0.73278C5.04307 0.611694 6.54498 1.91729 6.66607 3.6489C6.78716 5.38052 5.48156 6.88243 3.74995 7.00352C2.01833 7.1246 0.516419 5.81901 0.395333 4.08739Z" fill="white"/>
                                            </svg>
                                        </div>
                                        <button className="wasteland__btn wasteland__btn--right">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="23.3684" y="24" width="33.0479" height="0.893188" transform="rotate(-135 23.3684 24)" fill="currentColor"/>
                                                <rect x="24" y="24" width="16.0774" height="0.893188" transform="rotate(180 24 24)" fill="currentColor"/>
                                                <rect x="23.1068" y="24" width="16.0774" height="0.893188" transform="rotate(-90 23.1068 24)" fill="currentColor"/>
                                            </svg>
                                        </button>
                                    </div>
                                    <Swiper
                                        slidesPerView={2}
                                        spaceBetween={20}
                                        navigation={{
                                            nextEl: '.wasteland__btn--right',
                                            prevEl: '.wasteland__btn--left'
                                        }}
                                        modules={[Navigation, Autoplay]} 
                                        loop={true}
                                        autoplay={{
                                            delay: 2000,
                                            disableOnInteraction: false,
                                        }}
                                        className="wasteland__swiper"
                                        breakpoints={{
                                            481: {
                                                slidesPerView: 3
                                            }
                                        }}
                                    >
                                        {wastelandSwiper.map((x, i) => {
                                            return (
                                                <SwiperSlide key={i} className="wasteland__slide" >
                                                    <img src={x} alt="" className="wasteland__slide-img" />
                                                </SwiperSlide>
                                            )
                                        })}
                                    </Swiper>
                                    <div className="wasteland__abs">
                                        <img src={wastelands2} alt="" className="wasteland__abs-img wasteland__anim3" />
                                    </div>
                                </div>
                            </div>
                            <div className="wasteland__right">
                                <div className="wasteland__right-top">
                                    <p className="wasteland__subtitle wasteland__anim1">
                                        NFT Villages of
                                    </p>
                                    <h2 className="wasteland__title wasteland__anim1">
                                        <span className="wasteland__title--red">THE GREAT</span><br/>WASTELANDS
                                    </h2>
                                    <p className="wasteland__descr wasteland__anim2">
                                    The main purpose of NFT villages will emerge when the main game is launched. For now, they serve as 400 coins for voting within the DAO. Later, owning a village will act as a modifier in mini-games on the website. But when the mail game is ready, an NFT village will be a location on the map with your house, production facilities that need to be guarded, developed, and used to mine cryptocurrency, which can then be sold to regular users as ingame currency..
                                    <br></br>                           
                                    </p>
                                    {/* <p className="meet__descr meet__anim2">
                                        <br></br>
                                    Within the DAO, the village provides 400 returnable coins for voting.
                                    </p> */}
                                </div>
                                <div className="wasteland__right-bottom">
                                    <p className="wasteland__lands wasteland__anim2">
                                        <span className="wasteland__lands--red">54 000</span> NFT Villages
                                    </p>
                                    <p className="wasteland__descr wasteland__anim2">
                                        available to purchase before the game begins. Unsold villages will be destroyed.
                                        <br></br>
                                        <br></br>
                                        {/* <span className="metaverse__subtitle--boldred">Important: The division of lands into rarities will only make sense when/if the game is released, so it's a "preparation for the future." Currently, villages represent 400 votes for the DAO, and we'll use them in web games and the story builder.</span> */}


                                    </p>
                                    <p className="wasteland__descr wasteland__anim2">
                                    Rarity level determines the production type:
                                    </p>
                                </div>
                                <ul className="meet__list">
                                    <li className="meet__item">
                                    <br></br>
                                    <br></br>

                                        <p className="meet__item-descr meet__anim2">
                                        &mdash;&nbsp;Common: extraction
                                        </p>
                                        <p className="meet__item-descr meet__anim2">
                                            &mdash;&nbsp;Rare: processing
                                        </p>
                                        <p className="meet__item-descr meet__anim2">
                                            &mdash;&nbsp;Epic: manufactiring
                                        </p>
                                    </li>

                                </ul>
                            </div>
                        </div>
                        <div className="wasteland__center">
                            <div className="wasteland__center-top">
                                <p className="wasteland__lands wasteland__anim2">
                                    <span className="wasteland__lands--red">54 000</span> NFT Lands
                                </p>
                                <p className="wasteland__descr wasteland__center-descr wasteland__anim2">
                                    All settlements require protection from other players. The player will have to organise the defence of the settlement, construct a chain of production, exploring the world of the Great Wastelands.
                                </p>
                            </div>
                            <div className="wasteland__center-bottom">
                                <div className="wasteland__center-left">
                                    <p className="wasteland__lands wasteland__anim2">
                                        <span className="wasteland__lands--red">5dd4 000</span> NFT Lands
                                    </p>
                                    <p className="wasteland__descr wasteland__center-descr wasteland__anim2">
                                        All settlements require protection from other players. The player will have to organise the defence of the settlement, construct a chain of production, exploring the world of the Great Wastelands.
                                    </p>
                                    <p className="wasteland__descr wasteland__center-descr2 wasteland__anim2">
                                        There are a total of 50 different types of lands. There will be 54,000 settelments in the game. They are divided into the following types:
                                    </p>
                                </div>
                                <div className="wasteland__center-right">
                                    <img className="wasteland__center-img" src={wastelandsChoose1} alt="" style={{
                                        opacity: choose === 'common' ? 1 : 0
                                    }} />
                                    <img className="wasteland__center-img" src={wastelandsChoose2} alt="" style={{
                                        opacity: choose === 'rare' ? 1 : 0
                                    }} />
                                    <img className="wasteland__center-img wasteland__center-img3" src={wastelandsChoose3} alt="" style={{
                                        opacity: choose === 'epic' ? 1 : 0,
                                    }} />
                                </div>
                            </div>
                        {/* </div>                  //Блок про земли. Пока что уберу
                        <div className="wasteland__bottom landing-container">
                            <div className="wasteland__bottom-btns">
                                <button className="wasteland__bottom-btn" style={{
                                    background: 'linear-gradient(180deg, #44A3FC 0%, #166BB1 100%)'
                                }} onClick={() => {
                                    setChoose('common')
                                }}>
                                    <span className={`wasteland__bottom-btn--span ${choose === 'common' ? 'active' : ''}`} />
                                    <p className="wasteland__bottom-btn--descr">
                                        Common
                                    </p>
                                </button>
                                <button className="wasteland__bottom-btn" style={{
                                    background: 'linear-gradient(180deg, #4E327B 0%, #AC24FD 100%)'
                                }} onClick={() => {
                                    setChoose('rare')
                                }}>
                                    <span className={`wasteland__bottom-btn--span ${choose === 'rare' ? 'active' : ''}`} />
                                    <p className="wasteland__bottom-btn--descr">
                                        Rare
                                    </p>
                                </button>
                                <button className="wasteland__bottom-btn" style={{
                                    background: 'linear-gradient(0deg,rgba(196,144,0,1) 0,rgba(224,198,0,1) 100%)'
                                }} onClick={() => {
                                    setChoose('epic')
                                }}>
                                    <span className={`wasteland__bottom-btn--span ${choose === 'epic' ? 'active' : ''}`} />
                                    <p className="wasteland__bottom-btn--descr">
                                        Epic
                                    </p>
                                </button>
                            </div>
                            <div className="wasteland__bottom-left">
                                <p className="wasteland__bottom-title wasteland__anim3">
                                    <span className="wasteland__bottom-title--number">
                                        {choose === 'common' ? '01' : (choose === 'rare' ? '02' : '03')}
                                    </span>
                                    {choose === 'common' ? 'Extraction' : (choose === 'rare' ? 'Processing' : 'Manufacturing')}&nbsp;&mdash;
                                </p>
                                <p className="wasteland__bottom-descr wasteland__anim3">
                                    {choose === 'common' ? 'is a production type that is the most common and is also the easiest to manage. The only use of the extracted resources is to be sold for processing.' : (choose === 'rare' ? 'is a rare type of production. It converts a specific extracted resource into a refined resource or into a consumable item. The results of processing can be sold as well.' : 'is epic and most difficult production type. It allows player to create items from refined resources. These items are the most expensive and sought-after.')}
                                </p>
                            </div>
                            <div className="wasteland__bottom-separation" />
                            <div className="wasteland__bottom-right">
                                <img className="wasteland__bottom-img" src={wastelandsChoose1} alt="" style={{
                                    opacity: choose === 'common' ? 1 : 0
                                }} />
                                <img className="wasteland__bottom-img" src={wastelandsChoose2} alt="" style={{
                                    opacity: choose === 'rare' ? 1 : 0
                                }} />
                                <img className="wasteland__bottom-img wasteland__bottom-img3" src={wastelandsChoose3} alt="" style={{
                                    opacity: choose === 'epic' ? 1 : 0,
                                }} />
                            </div> */}
                        </div>
                    </section>
                    <section id="news" className="section news">
                        <div className="news__top landing-container news__anim1">
                            <div className="news__top-left">
                                {/* <p className="news__sort">
                                    Sort by:
                                </p>
                                <div className="news__filters">
                                    <button className="news__filter">
                                        Only news
                                    </button>
                                    <button className="news__filter">
                                        Only events
                                    </button>
                                    <button className="news__filter">
                                        Most recent
                                    </button>
                                    <button className="news__filter">
                                        The oldest
                                    </button>
                                    <button className="news__filter">
                                        Most liked
                                    </button>
                                </div> */}
                                <div className="news__selector">
                                    {/* <div className="news__selector-top" onClick={() => {animSelect.current.play()}}>
                                        <p className="news__selector-select">
                                            {select}
                                        </p>
                                        <button className="news__selector-open">
                                            <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4 6L7.4641 0H0.535898L4 6Z" fill="white"/>
                                            </svg>
                                        </button>
                                    </div> */}
                                    {/* <ul ref={selectorRef} className="news__selector-list">
                                        <li className="news__selector-item" onClick={() => {
                                            setSelect('Only news')
                                            animSelect.current.reverse()
                                        }}>
                                            <p className="news__selector-descr">
                                                Only news
                                            </p>
                                        </li>
                                        <li className="news__selector-item" onClick={() => {
                                            setSelect('Only events')
                                            animSelect.current.reverse()

                                        }}>
                                            <p className="news__selector-descr">
                                                Only events
                                            </p>
                                        </li>
                                        <li className="news__selector-item" onClick={() => {
                                            setSelect('Most recent')
                                            animSelect.current.reverse()

                                        }}>
                                            <p className="news__selector-descr">
                                                Most recent
                                            </p>
                                        </li>
                                        <li className="news__selector-item" onClick={() => {
                                            setSelect('The oldest')
                                            animSelect.current.reverse()

                                        }}>
                                            <p className="news__selector-descr">
                                                The oldest
                                            </p>
                                        </li>
                                        <li className="news__selector-item" onClick={() => {
                                            setSelect('Most liked')
                                            animSelect.current.reverse()

                                        }}>
                                            <p className="news__selector-descr">
                                                Most liked
                                            </p>
                                        </li>
                                        <li className="news__selector-item" onClick={() => {animSelect.current.reverse()}}>
                                            <button className="news__selector-close">
                                                <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M4 0L0.535898 6H7.4641L4 0Z" fill="white"/>
                                                </svg>
                                            </button>
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                            <h2 className="news__top-right news__title">
                                Last News &amp;&nbsp;Events
                            </h2>
                        </div>
                        <div className="news__bottom landing-container news__anim2">
                            <Swiper 
                                spaceBetween={50}
                                slidesPerView={1}
                                modules={[Autoplay]} 
                                loop={true}
                                autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: false,
                                }}
                                className="news__swiper"
                                breakpoints={{
                                    961: {
                                        spaceBetween: 150
                                    }
                                }}
                            >
                                {news.map((x, i) => {
                                    return (
                                        <SwiperSlide key={i} className="news__slide">
                                            <div className="news__slide-card">
                                                <div className="news__slide-top">
                                                    <img src={x.img} alt="" className="news__slide-left" />
                                                    <div className="news__slide-right">
                                                        <h4 className="news__slide-title">
                                                            {x.title}
                                                        </h4>
                                                        <p className="news__slide-subtitle">
                                                            {x.subtitle}
                                                        </p>
                                                        <p className="news__slide-descr">
                                                            {x.descr}
                                                        </p>
                                                        <div className="news__slide-infos">
                                                            <p className="news__slide-date">
                                                                {x.date}
                                                            </p>
                                                            <p className="news__slide-time">
                                                                {x.time} read
                                                            </p>
                                                            <a href={`${x.themeLink}`} className="news__slide-theme">
                                                                {x.theme}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="news__slide-bottom">
                                                    <p className="news__slide-date">
                                                        {x.date}
                                                    </p>
                                                    <p className="news__slide-time">
                                                        {x.time} read
                                                    </p>
                                                    <a href={`${x.themeLink}`} className="news__slide-theme">
                                                        {x.theme}
                                                    </a>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    )
                                })}
                            </Swiper>
                        </div>
                    </section>
                </div>
                <section id="contacts" className="section contacts">
                    <BackgroundSwiper>
                        <div className="root__bg root__bg1"  style={{ backgroundImage: `linear-gradient(to bottom, rgba(0,27,77,0.9), rgba(20,20,28,0.9)), url(${heroBg1})` }} />
                        <div className="root__bg root__bg2"  style={{ backgroundImage: `linear-gradient(to bottom, rgba(0,27,77,0.9), rgba(20,20,28,0.9)), url(${heroBg2})` }} />
                        <div className="root__bg root__bg3"  style={{ backgroundImage: `linear-gradient(to bottom, rgba(0,27,77,0.9), rgba(20,20,28,0.9)), url(${heroBg3})` }} />
                    </BackgroundSwiper>
                    <div className="contacts__container landing-container">
                        <div className="contacts__left">
                            <h2 className="contacts__title contacts__anim1">
                                CONTACTS
                            </h2>
                            <p className="contacts__subtitle contacts__anim2">
                                Any questions? Contact us.
                            </p>
                            <a href="mailto:welcome@rgw.zone" rel="noopener noreferrer" className="contacts__email contacts__anim2">
                                welcome@rgw.zone
                            </a>
                            {/* <form action="" className="contacts__form contacts__anim2">
                                <p className="contacts__name">
                                    Your email
                                </p>
                                <input type="text" className="contacts__input" placeholder="mail@example.com" />
                                <p className="contacts__name">
                                    Your mame
                                </p>
                                <input type="text" className="contacts__input" placeholder="John Doe" />
                                <button className="contacts__submit">
                                    Submit
                                </button>
                            </form> */}
                        </div>
                        <div className="contacts__right">
                            <div className="contacts__grid contacts__anim2">
                                <a href="https://t.me/raidersgame" rel="noopener noreferrer" target={'_blank'} className="contacts__soc">
                                    <svg className="contacts__soc-svg" width="33" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M32 1L1 12.6666L9.85715 17.3333L23.1428 7.99997L14.2857 19.6667L27.5715 29L32 1Z" stroke="currentColor" strokeLinejoin="round"/>
                                    </svg>
                                    <p className="contacts__soc-descr">
                                        TELEGRAM
                                    </p>
                                </a>
                                <a href="https://discord.gg/QvdcgcWn" rel="noopener noreferrer" target={'_blank'} className="contacts__soc">
                                    <svg className="contacts__soc-svg" width="34" height="29" viewBox="0 0 34 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M26.2517 28.2007L25.7234 28.8064C25.8771 28.9369 26.0748 29.0058 26.2773 28.9996L26.2517 28.2007ZM23.5126 24.5033C23.2356 24.1569 22.7266 24.0978 22.3756 24.3713C22.0247 24.6447 21.9648 25.1474 22.2418 25.4938L23.5126 24.5033ZM24.707 23.3563L24.4254 22.6069C24.4146 22.6109 24.4041 22.6151 24.3934 22.6194L24.707 23.3563ZM20.6872 24.5332L20.5512 23.7453L20.5381 23.7477L20.6872 24.5332ZM13.5069 24.506L13.3534 25.2907L13.3583 25.2916L13.5069 24.506ZM7.4075 22.3985L6.95739 23.0628C6.97515 23.0745 6.99338 23.0855 7.01203 23.0957L7.4075 22.3985ZM7.1581 22.2615L7.6075 21.5967C7.57946 21.5782 7.55028 21.5616 7.52012 21.5467L7.1581 22.2615ZM7.04723 22.1795L7.61964 21.6145C7.56647 21.5619 7.50615 21.517 7.44041 21.481L7.04723 22.1795ZM11.758 25.4388C12.035 25.0925 11.975 24.5898 11.6241 24.3164C11.2731 24.0429 10.7641 24.1021 10.4871 24.4486L11.758 25.4388ZM7.74829 28.2007L7.72268 28.9996C7.92877 29.006 8.12958 28.9345 8.28415 28.7998L7.74829 28.2007ZM0.809524 23.0553H0C0 23.0981 0.0034743 23.1408 0.0103894 23.183L0.809524 23.0553ZM4.80166 3.67327L4.31594 3.03393C4.19197 3.12571 4.09731 3.2507 4.04317 3.39403L4.80166 3.67327ZM12.5919 0.799432L13.3977 0.723667C13.3588 0.320149 13.0201 0.00930694 12.6096 0.000419787L12.5919 0.799432ZM12.0633 3.74925C12.1057 4.18865 12.5008 4.51092 12.9459 4.46907C13.391 4.42723 13.7174 4.03709 13.675 3.5977L12.0633 3.74925ZM20.2169 3.68111C20.1599 4.11889 20.4732 4.51939 20.9166 4.57562C21.3601 4.63184 21.7658 4.32253 21.8227 3.88474L20.2169 3.68111ZM21.4079 0.799624L21.3902 0.000611666C20.9898 0.00929102 20.656 0.305668 20.605 0.697805L21.4079 0.799624ZM29.1981 3.67347L29.9566 3.39421C29.9025 3.25088 29.8078 3.12592 29.6839 3.03412L29.1981 3.67347ZM33.1905 23.0553L33.9896 23.183C33.9966 23.1408 34 23.0981 34 23.0553H33.1905ZM14.6434 17.4717L13.8339 17.4586V17.4717H14.6434ZM26.2517 28.2007C26.78 27.5952 26.78 27.5952 26.78 27.5952C26.7799 27.5951 26.7802 27.5954 26.78 27.5952C26.7799 27.5951 26.779 27.5944 26.7786 27.594C26.7774 27.593 26.7757 27.5916 26.7734 27.5896C26.7689 27.5857 26.7619 27.5797 26.7528 27.5721C26.7345 27.5564 26.7073 27.5331 26.6724 27.503C26.6024 27.4429 26.5012 27.3556 26.377 27.2474C26.1284 27.0308 25.7887 26.7318 25.4239 26.4011C24.6762 25.7232 23.8818 24.9649 23.5126 24.5033L22.2418 25.4938C22.7046 26.0724 23.5971 26.9151 24.3288 27.5783C24.7038 27.9181 25.0517 28.2245 25.3059 28.4459C25.433 28.5567 25.5369 28.6465 25.6093 28.7087C25.6454 28.7397 25.6737 28.764 25.6932 28.7805C25.7029 28.7888 25.7103 28.7952 25.7153 28.7995C25.7179 28.8016 25.7199 28.8033 25.7212 28.8044C25.7218 28.8051 25.7231 28.806 25.7234 28.8064C25.7233 28.8062 25.7236 28.8065 25.7234 28.8064C25.7236 28.8065 25.7234 28.8064 26.2517 28.2007ZM27.45 21.0741C26.3646 21.7798 25.3383 22.2725 24.4254 22.6069L24.9887 24.1054C26.0165 23.729 27.1526 23.1814 28.3405 22.409L27.45 21.0741ZM24.3934 22.6194C23.0604 23.1723 21.7891 23.5372 20.5512 23.7453L20.8231 25.321C22.1912 25.091 23.5814 24.69 25.0206 24.093L24.3934 22.6194ZM20.5381 23.7477C17.993 24.2188 15.6561 24.089 13.6554 23.7202L13.3583 25.2916C15.5159 25.6891 18.0582 25.833 20.8363 25.3188L20.5381 23.7477ZM13.6603 23.7212C12.139 23.4312 10.8285 23.0093 9.72578 22.5846L9.13648 24.0733C10.3068 24.5241 11.714 24.9782 13.3534 25.2907L13.6603 23.7212ZM9.72578 22.5846C9.1103 22.3467 8.45408 22.0609 7.80297 21.7011L7.01203 23.0957C7.7474 23.5022 8.47652 23.8184 9.13648 24.0733L9.72578 22.5846ZM7.85761 21.7342C7.76754 21.6747 7.68159 21.6332 7.64506 21.6153C7.59821 21.5921 7.60081 21.5923 7.6075 21.5967L6.7087 22.9263C6.79858 22.9854 6.88438 23.0268 6.92068 23.0447C6.9673 23.0678 6.96445 23.0674 6.95739 23.0628L7.85761 21.7342ZM7.52012 21.5467C7.54318 21.5581 7.57023 21.5745 7.59715 21.5958C7.61961 21.6135 7.63493 21.6295 7.61964 21.6145L6.47481 22.7447C6.52054 22.7898 6.62231 22.8905 6.79607 22.9763L7.52012 21.5467ZM7.44041 21.481C7.2053 21.352 7.02429 21.2433 6.90427 21.1685C6.84428 21.1311 6.79961 21.1022 6.77112 21.0835C6.75688 21.0741 6.74669 21.0672 6.74066 21.0632C6.73765 21.0611 6.73568 21.0598 6.73475 21.0592C6.7343 21.0589 6.73469 21.0592 6.73475 21.0592C6.73482 21.0592 6.73517 21.0595 6.27098 21.7142C5.80678 22.3689 5.80683 22.3691 5.80689 22.3691C5.80686 22.3691 5.80691 22.3691 5.80689 22.3691C5.80733 22.3694 5.80882 22.3704 5.8094 22.3708C5.81055 22.3716 5.81198 22.3726 5.81366 22.3737C5.81704 22.376 5.82151 22.379 5.82707 22.3828C5.83814 22.3903 5.85352 22.4006 5.87306 22.4134C5.91215 22.4391 5.96799 22.4752 6.0397 22.52C6.18305 22.6093 6.39017 22.7334 6.65404 22.8782L7.44041 21.481ZM10.4871 24.4486C10.1153 24.9138 9.31741 25.6879 8.57006 26.3792C8.20486 26.7171 7.86488 27.0232 7.61607 27.245C7.49175 27.3558 7.39043 27.4453 7.32036 27.507C7.28534 27.5379 7.25814 27.5617 7.2398 27.5778C7.23063 27.5858 7.22369 27.5919 7.21909 27.5959C7.21679 27.598 7.21508 27.5994 7.21396 27.6004C7.21341 27.6008 7.213 27.6012 7.21274 27.6015C7.21274 27.6015 7.21245 27.6016 7.74829 28.2007C8.28415 28.7998 8.28412 28.7998 8.28415 28.7998C8.2845 28.7995 8.28565 28.7985 8.28633 28.7979C8.28768 28.7968 8.28962 28.795 8.29215 28.7928C8.29721 28.7885 8.30465 28.7819 8.31431 28.7734C8.33363 28.7565 8.36188 28.7317 8.398 28.6999C8.47023 28.6363 8.57404 28.5445 8.7011 28.4314C8.95503 28.205 9.30269 27.8919 9.67711 27.5455C10.409 26.8684 11.2983 26.0139 11.758 25.4388L10.4871 24.4486ZM7.77392 27.402C4.96761 27.3142 3.45571 26.1541 2.62652 25.0736C2.20179 24.5201 1.94394 23.9702 1.79305 23.5597C1.71789 23.3553 1.67021 23.188 1.64204 23.0761C1.62797 23.0201 1.61883 22.9782 1.6136 22.9527C1.61098 22.9399 1.60935 22.9312 1.60857 22.9269C1.60818 22.9249 1.608 22.9237 1.60802 22.9239C1.60792 22.9233 1.60803 22.9239 1.60802 22.9239C1.60808 22.9242 1.60849 22.9265 1.60857 22.9269C1.60855 22.9268 1.60861 22.9271 1.60857 22.9269C1.60864 22.9273 1.60866 22.9277 0.809524 23.0553C0.0103894 23.183 0.010308 23.1825 0.0103894 23.183C0.0104209 23.1832 0.0106657 23.1846 0.010729 23.1851C0.0108558 23.1859 0.0109963 23.1867 0.0111509 23.1876C0.01146 23.1894 0.0118252 23.1915 0.0122487 23.194C0.0130957 23.1988 0.0141762 23.2049 0.0155085 23.2122C0.0181725 23.2266 0.0218455 23.2458 0.0266724 23.2695C0.0363224 23.3166 0.050609 23.3814 0.0707049 23.4611C0.110851 23.6208 0.174464 23.842 0.27114 24.1051C0.463917 24.6294 0.791947 25.3298 1.33603 26.0389C2.44447 27.4832 4.40196 28.8957 7.72268 28.9996L7.77392 27.402ZM1.61905 23.0553C1.61905 18.7503 2.59694 13.9822 3.58846 10.2628C4.08264 8.40902 4.57687 6.82786 4.94723 5.71105C5.13235 5.15284 5.28637 4.71114 5.39374 4.40995C5.44742 4.25938 5.48943 4.14396 5.51781 4.06671C5.53201 4.02809 5.54279 3.99901 5.54993 3.97985C5.55351 3.97027 5.55617 3.96318 5.55788 3.95861C5.55874 3.95632 5.55936 3.95467 5.55974 3.95365C5.55973 3.95367 5.56017 3.95253 4.80166 3.67327C4.04317 3.39403 4.04323 3.39386 4.04317 3.39403C4.04313 3.39414 4.04325 3.39379 4.04317 3.39403C4.043 3.39448 4.04242 3.396 4.04213 3.39677C4.04155 3.39832 4.04072 3.40052 4.03965 3.40335C4.03753 3.40899 4.03447 3.41719 4.03049 3.42789C4.02252 3.44926 4.01088 3.4806 3.99584 3.52154C3.96576 3.60342 3.922 3.72367 3.86651 3.87931C3.75556 4.19054 3.59769 4.64338 3.40855 5.21371C3.03039 6.354 2.52659 7.96588 2.02272 9.85598C1.01818 13.6244 0 18.5473 0 23.0553H1.61905ZM5.28739 4.31264C7.18056 2.91083 9.02315 2.23255 10.3857 1.90428C11.0671 1.74014 11.6272 1.66387 12.0111 1.62854C12.203 1.6109 12.3505 1.60351 12.4468 1.60047C12.4949 1.59896 12.5301 1.59852 12.5517 1.59843C12.5624 1.59838 12.5698 1.59843 12.5735 1.59846C12.5754 1.59848 12.5764 1.59849 12.5766 1.59849C12.5764 1.59849 12.5736 1.59846 12.5735 1.59846C12.5732 1.59846 12.5741 1.59844 12.5919 0.799432C12.6096 0.000419723 12.61 0.000435771 12.6096 0.000419787C12.6095 0.000419787 12.6099 0.000435771 12.6096 0.000419787C12.6091 0.000419787 12.607 0.000371748 12.6063 0.000355764C12.605 0.00033978 12.6035 0.000307894 12.6017 0.000275926C12.5981 0.000227973 12.5936 0.000164011 12.5882 0.000116058C12.5773 2.01539e-05 12.5629 -4.37004e-05 12.5448 3.622e-05C12.5088 0.000196061 12.4585 0.000883239 12.395 0.00288125C12.2679 0.00689325 12.0875 0.0161961 11.8609 0.0370233C11.408 0.0786938 10.7691 0.166622 10.0019 0.351446C8.46742 0.72111 6.41489 1.47975 4.31594 3.03393L5.28739 4.31264ZM11.786 0.875213L12.0633 3.74925L13.675 3.5977L13.3977 0.723667L11.786 0.875213ZM21.8227 3.88474L22.2109 0.901443L20.605 0.697805L20.2169 3.68111L21.8227 3.88474ZM21.4079 0.799624C21.4257 1.59864 21.4253 1.59864 21.4252 1.59865C21.4289 1.59862 21.4375 1.59857 21.4482 1.59862C21.4697 1.5987 21.505 1.59913 21.5531 1.60065C21.6493 1.60369 21.7968 1.61107 21.9888 1.62872C22.3726 1.66401 22.9327 1.74027 23.6141 1.90441C24.9767 2.23265 26.8192 2.91093 28.7124 4.31281L29.6839 3.03412C27.5848 1.47984 25.5324 0.721206 23.9978 0.351558C23.2307 0.16675 22.5917 0.0788377 22.1389 0.0371832C21.9122 0.0163559 21.7318 0.00706913 21.6047 0.00305712C21.5413 0.00105911 21.4911 0.000371765 21.455 0.000227908C21.4368 0.000147988 21.4224 0.000212033 21.4116 0.000307937C21.4062 0.00035589 21.4017 0.000419852 21.3981 0.000467805C21.3964 0.000499773 21.3947 0.000515675 21.3934 0.000547643C21.3928 0.000563627 21.3907 0.000595682 21.3902 0.000611666C21.3899 0.000611666 21.3904 0.000611666 21.3902 0.000611666C21.3899 0.00062765 21.3902 0.000611793 21.4079 0.799624ZM29.1981 3.67347C28.4397 3.95274 28.4397 3.95268 28.4395 3.95266C28.44 3.95368 28.441 3.95653 28.442 3.95881C28.4436 3.96339 28.4463 3.97048 28.4499 3.98006C28.457 3.99922 28.4679 4.0283 28.482 4.06691C28.5105 4.14417 28.5524 4.25957 28.6061 4.41016C28.7135 4.71133 28.8675 5.15303 29.0527 5.71123C29.423 6.828 29.9172 8.40915 30.4114 10.2629C31.403 13.9822 32.381 18.7503 32.381 23.0553H34C34 18.5473 32.9818 13.6244 31.9772 9.85606C31.4733 7.96599 30.9695 6.35412 30.5913 5.21385C30.4022 4.64354 30.2443 4.19069 30.1332 3.87947C30.0779 3.72385 30.034 3.60358 30.004 3.52171C29.989 3.48078 29.9773 3.44943 29.9694 3.42806C29.9653 3.41737 29.9623 3.40917 29.9602 3.40351C29.959 3.40068 29.9582 3.39849 29.9577 3.39694C29.9574 3.39616 29.9568 3.39467 29.9566 3.39421C29.9566 3.39398 29.9566 3.39432 29.9566 3.39421C29.9566 3.39403 29.9566 3.39421 29.1981 3.67347ZM33.1905 23.0553C32.3913 22.9277 32.3915 22.9273 32.3915 22.9268C32.3915 22.9263 32.3918 22.9252 32.3918 22.9249C32.3918 22.9247 32.3918 22.9247 32.3915 22.9268C32.3907 22.9311 32.389 22.9399 32.3865 22.9527C32.3811 22.9781 32.372 23.02 32.358 23.0759C32.3298 23.188 32.282 23.3553 32.2069 23.5597C32.056 23.9702 31.7981 24.5201 31.3734 25.0736C30.5441 26.1541 29.0323 27.3142 26.2261 27.402L26.2773 28.9996C29.598 28.8957 31.5554 27.4832 32.664 26.0389C33.208 25.3298 33.536 24.6294 33.7288 24.1051C33.8255 23.842 33.8891 23.6208 33.9292 23.4613C33.9493 23.3814 33.9637 23.3166 33.9733 23.2695C33.9781 23.246 33.9819 23.2266 33.9845 23.2122C33.9858 23.2049 33.9869 23.1988 33.9877 23.194C33.9882 23.1916 33.9885 23.1894 33.9888 23.1876C33.989 23.1867 33.9892 23.1859 33.9893 23.1851C33.9893 23.1848 33.9896 23.1832 33.9896 23.183C33.9896 23.1825 33.9896 23.183 33.1905 23.0553ZM11.8156 13.6346C9.72058 13.6346 8.17852 15.4309 8.17852 17.4717H9.79757C9.79757 16.1737 10.7503 15.233 11.8156 15.233V13.6346ZM8.17852 17.4717C8.17852 19.518 9.75313 21.309 11.8156 21.309V19.7106C10.7731 19.7106 9.79757 18.7648 9.79757 17.4717H8.17852ZM11.8156 21.309C13.9109 21.309 15.4529 19.5127 15.4529 17.4717H13.8339C13.8339 18.7701 12.8811 19.7106 11.8156 19.7106V21.309ZM15.4528 17.4848C15.4872 15.4211 13.8992 13.6346 11.8156 13.6346V15.233C12.8924 15.233 13.8551 16.1834 13.8339 17.4586L15.4528 17.4848ZM21.9349 13.6346C19.8396 13.6346 18.2973 15.4307 18.2973 17.4717H19.9164C19.9164 16.1737 20.8692 15.233 21.9349 15.233V13.6346ZM18.2973 17.4717C18.2973 19.5182 19.8724 21.309 21.9349 21.309V19.7106C20.8922 19.7106 19.9164 18.7647 19.9164 17.4717H18.2973ZM21.9349 21.309C24.0299 21.309 25.5719 19.5127 25.5719 17.4717H23.9528C23.9528 18.7701 23 19.7106 21.9349 19.7106V21.309ZM25.5719 17.4717C25.5719 15.4309 24.0299 13.6346 21.9349 13.6346V15.233C23 15.233 23.9528 16.1737 23.9528 17.4717H25.5719ZM8.13589 7.20967C11.502 5.39732 14.2786 4.53232 17.0052 4.531C19.7315 4.52967 22.5043 5.39166 25.8627 7.20887L26.6408 5.8072C23.1477 3.91706 20.101 2.93107 17.0045 2.93259C13.9084 2.93411 10.8591 3.92279 7.36071 5.8064L8.13589 7.20967Z" fill="currentColor"/>
                                    </svg>
                                    <p className="contacts__soc-descr">
                                        DISCORD
                                    </p>
                                </a>
                                <a href="/" rel="noopener noreferrer" target={'_blank'} className="contacts__soc">
                                    <svg className="contacts__soc-svg" width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M25.025 8.75H26.575M7.2 1H25.8C29.2241 1 32 3.77583 32 7.2V25.8C32 29.2241 29.2241 32 25.8 32H7.2C3.77583 32 1 29.2241 1 25.8V7.2C1 3.77583 3.77583 1 7.2 1ZM16.5 22.7C13.0758 22.7 10.3 19.9241 10.3 16.5C10.3 13.0758 13.0758 10.3 16.5 10.3C19.9241 10.3 22.7 13.0758 22.7 16.5C22.7 19.9241 19.9241 22.7 16.5 22.7Z" stroke="currentColor" strokeWidth="2"/>
                                    </svg>
                                    <p className="contacts__soc-descr">
                                        INSTAGRAM
                                    </p>
                                </a>
                                <a href="https://www.youtube.com/@rgwzone" rel="noopener noreferrer" target={'_blank'} className="contacts__soc">
                                    <svg className="contacts__soc-svg" width="33" height="28" viewBox="0 0 33 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.3571 9.07093L13.7614 8.37501C13.5187 8.22458 13.2163 8.22063 12.97 8.3647C12.7237 8.50876 12.5714 8.77854 12.5714 9.07093H13.3571ZM13.3571 18.8098H12.5714C12.5714 19.1022 12.7237 19.3719 12.97 19.5161C13.2163 19.66 13.5187 19.6561 13.7614 19.5057L13.3571 18.8098ZM21.2143 13.9404L21.6185 14.6362C21.8553 14.4897 22 14.2254 22 13.9404C22 13.6554 21.8553 13.3911 21.6185 13.2444L21.2143 13.9404ZM0 5.44455V22.4869H1.57143V5.44455H0ZM33 22.4869V5.44455H31.4286V22.4869H33ZM3.30448 26.6504C12.0152 28.4499 20.9847 28.4499 29.6956 26.6504L29.3873 25.0588C20.88 26.8162 12.12 26.8162 3.61267 25.0588L3.30448 26.6504ZM29.8851 1.46469C21.0619 -0.48823 11.9381 -0.48823 3.11487 1.46469L3.44413 3.0518C12.0504 1.14691 20.9497 1.14691 29.5559 3.0518L29.8851 1.46469ZM33 5.44455C33 3.52529 31.702 1.86683 29.8851 1.46469L29.5559 3.0518C30.6482 3.29357 31.4286 4.29067 31.4286 5.44455H33ZM31.4286 22.4869C31.4286 23.7371 30.5742 24.8135 29.3873 25.0588L29.6956 26.6504C31.617 26.2534 33 24.5108 33 22.4869H31.4286ZM0 22.4869C0 24.5108 1.38307 26.2534 3.30448 26.6504L3.61267 25.0588C2.42577 24.8135 1.57143 23.7371 1.57143 22.4869H0ZM1.57143 5.44455C1.57143 4.29067 2.35182 3.29357 3.44413 3.0518L3.11487 1.46469C1.29801 1.86683 0 3.52529 0 5.44455H1.57143ZM12.5714 9.07093V18.8098H14.1429V9.07093H12.5714ZM13.7614 19.5057L21.6185 14.6362L20.8101 13.2444L12.9529 18.1138L13.7614 19.5057ZM21.6185 13.2444L13.7614 8.37501L12.9529 9.76684L20.8101 14.6362L21.6185 13.2444Z" fill="currentColor"/>
                                    </svg>
                                    <p className="contacts__soc-descr">
                                        YOUTUBE
                                    </p>
                                </a>
                            </div>
                            <p className="contacts__copyright contacts__anim2">
                                &copy;RAIDERS OF THE GREAT WASTELANDS
                            </p>
                            <p className="contacts__descr contacts__anim2">
                                The contents of all material available on this site are copyrighted by the © RAIDERS OF THE GREAT WASTELANDS. All rights reserved.
                            </p>
                            <p className="contacts__year contacts__anim2">
                                2024
                            </p>
                        </div>
                    </div>
                    <div className="contacts__bg">
                        <img src={contactsBg1} alt="" className="contacts__bg1" />
                        <img src={contactsBg2} alt="" className="contacts__bg2" />
                        <img src={contactsBg3} alt="" className="contacts__bg3" />
                        <img src={contactsBg4} alt="" className="contacts__bg4" />
                        <img src={contactsBg5} alt="" className="contacts__bg5" />
                        <img src={contactsBg6} alt="" className="contacts__bg6" />
                    </div>
                </section>
            </main>
            <footer className="footer">
                <div className="footer__container">
                    <div className="footer__left">
                        <LinkTo
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={750} 
                            to="hero"
                            className="footer__link"
                        >
                            <img src={Logo} className="footer__logo-svg"/>
                        </LinkTo>
                        <LinkTo
                            spy={true}
                            smooth={true}
                            offset={50}
                            duration={750} 
                            to="meet"
                            className="footer__link"
                        >
                            Raiders
                        </LinkTo>
                        <LinkTo
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={750} 
                            to="metaverse"
                            className="footer__link"
                        >
                            Idea
                        </LinkTo>
                        <LinkTo
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={750} 
                            to="mystery"
                            className="footer__link"
                        >
                            Titles
                        </LinkTo>
                        <LinkTo
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={750} 
                            to="wasteland"
                            className="footer__link"
                        >
                            Villages
                        </LinkTo>
                        <LinkTo
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={750} 
                            to="news"
                            className="footer__link"
                        >
                            News
                        </LinkTo>
                        <LinkTo
                            spy={true}
                            smooth={true}
                            offset={50}
                            duration={750} 
                            to="contacts"
                            className="footer__link"
                        >
                            Contacts
                        </LinkTo>
                        <a href="https://constitution.rgw.zone/" target="_blank" className="footer__link">
                             Constitution
                        </a>

                    </div>
                    <div className="footer__right">
                        <a href="https://drive.google.com/file/d/1_M5_PJ_9yzcGRk0-ZbxUhYeZyBhI3hz4/view?usp=drive_link" rel="noopener noreferrer" target={'_blank'} className="footer__privacy">
                            Privacy policy
                        </a>
                        {/* <a style={{
                            marginRight: '100px'
                        }} href="https://devspace.pw/" target={'_blank'} rel="noopener noreferrer" className="footer__dev">
                            dev.space
                        </a> */}
                        
                    </div>
                </div>
            </footer>
        </>
    )
}
